<template>
  <div>
    <v-layout row warp>
      <v-flex xs12 text-xs-right>
        <v-dialog
          v-model="openDialogChat"
          persistent
          scrollable
          max-width="500px"
        >
          <v-card>
            <v-toolbar>
              <v-icon large color="black">message</v-icon>
              <v-toolbar-title>
                <h3>WESERVE CHAT APPLICATION</h3>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn @click="closeDialogChat" icon>
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text
              style="height: 750px; background-color: #ffd600; overflow: hidden"
              v-if="isLoading == false"
            >
              <iframe
                v-if="chatProvider == 'weserve'"
                class="chat-log"
                :src="urlsEndcode"
                title="chat application"
              ></iframe>
              <div v-else class="chat-wrapper">
                <!-- Connection / Status Bar -->
                <div class="status-bar">
                  <div class="status-left">
                    <span class="dot" :class="connectionClass"></span>
                    <span class="status-text">{{ connectionStatus }}</span>
                    <span
                      class="history-indicator"
                      v-if="historyLoading && messages.length"
                      >Loading older…</span
                    >
                  </div>
                  <div class="status-right">
                    <v-btn
                      x-small
                      icon
                      @click="reconnect"
                      :disabled="connecting || isWsOpen"
                    >
                      <v-icon small>autorenew</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- Messages Area -->
                <div
                  class="chat-messages"
                  ref="messagesContainer"
                  @scroll.passive="onScrollMessages"
                >
                  <div
                    v-if="historyLoading && messages.length === 0"
                    class="loading-block"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="28"
                    ></v-progress-circular>
                    <span>Loading conversation…</span>
                  </div>
                  <div
                    v-else-if="!historyLoading && messages.length === 0"
                    class="empty"
                  >
                    No messages yet.
                  </div>
                  <template v-for="(item, idx) in groupedItems">
                    <div
                      v-if="item.type === 'date'"
                      :key="item.key || 'd-' + idx"
                      class="date-separator"
                    >
                      <span>{{ item.label }}</span>
                    </div>
                    <div
                      v-else-if="item.type === 'message'"
                      :key="item.key || 'm-' + idx"
                      class="message-row"
                      :class="{
                        mine:
                          item.msg.from && item.msg.from.userId === chatUserId,
                        [`role-${item.msg.from && item.msg.from.role}`]: true,
                      }"
                    >
                      <div class="bubble">
                        <div class="bubble-meta">
                          <span
                            class="role"
                            :class="`r-${item.msg.from && item.msg.from.role}`"
                            >{{
                              (item.msg.from && item.msg.from.role) || "system"
                            }}</span
                          >
                          <span class="time">{{
                            formatTime(item.msg.ts)
                          }}</span>
                        </div>
                        <div
                          v-if="item.msg.type === 'message'"
                          class="bubble-text"
                        >
                          {{ item.msg.message }}
                        </div>
                        <div
                          v-else-if="item.msg.type === 'image'"
                          class="bubble-image"
                        >
                          <img :src="item.msg.imageUrl" alt="image" />
                        </div>
                        <div v-else class="bubble-text alt">
                          {{ item.msg.type }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <div
                    v-if="hasMoreHistory && !historyLoading"
                    class="top-fade"
                  />
                </div>

                <!-- Composer -->
                <div class="composer">
                  <v-form @submit.prevent="sendMessage" class="composer-form">
                    <div class="composer-row">
                      <v-btn
                        icon
                        small
                        class="attach-btn"
                        :disabled="!isWsOpen"
                        @click.prevent="chooseAttachment"
                      >
                        <v-icon small>attach_file</v-icon>
                      </v-btn>
                      <v-text-field
                        v-model="inputText"
                        placeholder="Type a message"
                        dense
                        hide-details
                        solo
                        flat
                        class="composer-input"
                        @keyup.enter.exact.prevent="sendMessage"
                      ></v-text-field>
                      <v-btn
                        color="primary"
                        small
                        class="send-btn"
                        :disabled="!inputText || !isWsOpen"
                        @click="sendMessage"
                      >
                        <v-icon small left>send</v-icon>Send
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </div>
            </v-card-text>
            <v-card-text
              v-else
              style="
                height: 750px;
                background-color: #ffd600;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                width="100px"
                height="100px"
                class="img-animate"
                src="@/assets/Pos/user.png"
              />
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
export default {
  props: [
    "openDialogChat",
    "order_detail",
    "statusBtn",
    "order_detail_message",
    "provinceData",
  ],
  data() {
    return {
      params: "https://clients.takeachat.com/chatroom/",
      endCode: "",
      chatProvider: "weserve",
      isLoading: false,
      // New WS chat related state
      ws: null,
      wsReadyState: WebSocket.CLOSED,
      messages: [],
      inputText: "",
      connectionStatus: "Idle",
      chatJwt: null,
      connecting: false,
      // History state
      historyLoading: false,
      hasMoreHistory: true,
      historyOldestTs: null,
      messageKeys: new Set(),
    };
  },
  watch: {
    async openDialogChat(newValue, oldValue) {
      if (newValue === true) {
        this.resetChatState();
        this.isLoading = true;
        let result = await this.getOrderChatSetting({
          province: this.$route.params.province,
        });

        this.isLoading = false;
        if (result === false) return;
        this.chatProvider = result;
        if (this.chatProvider !== "weserve") {
          // Initialize our websocket chat when dialog opens
          this.initChat();
        }
      } else {
        // Dialog closed
        this.teardownWs();
      }
    },
  },
  computed: {
    urlsEndcode() {
      let province = this.provinceData.find((value) => {
        return (
          this.splitProvince(value.province_name_en).toString().toLowerCase() ==
          this.$route.params.province
        );
      });
      if (province) {
        if (this.statusBtn == "order_detail") {
          this.endCode = btoa(
            `id=9999999&room=${this.order_detail.order_code}&provinceId=${
              province.province_id
            }&username=Admin&usertype=3&accesstoken=${localStorage.getItem(
              "token"
            )}`
          );
          console.log(`${this.params}${this.endCode}`);
          return `${this.params}${this.endCode}`;
        } else if (this.statusBtn == "oder_mess_detail") {
          this.endCode = btoa(
            `id=9999999&room=${
              this.order_detail_message.order_code
            }&provinceId=${
              province.province_id
            }&username=Admin&usertype=3&accesstoken=${localStorage.getItem(
              "token"
            )}`
          );
          console.log(`${this.params}${this.endCode}`);
          return `${this.params}${this.endCode}`;
        }
      }
    },
    groupedItems() {
      // Create an array that injects date separators
      if (!this.messages.length) return [];
      const out = [];
      let lastDate = null;
      this.messages.forEach((m) => {
        const d = new Date(m.ts || Date.now());
        const keyDate = d.toISOString().slice(0, 10); // YYYY-MM-DD
        if (keyDate !== lastDate) {
          lastDate = keyDate;
          out.push({
            type: "date",
            key: "date-" + keyDate,
            label: d.toLocaleDateString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
          });
        }
        out.push({
          type: "message",
          msg: m,
          key: "msg-" + (m.ts || Math.random()),
        });
      });
      return out;
    },
    currentOrder() {
      if (this.statusBtn === "order_detail" && this.order_detail)
        return this.order_detail;
      if (this.order_detail_message) return this.order_detail_message;
      return null;
    },
    roomId() {
      return this.currentOrder ? `order:${this.currentOrder.order_code}` : null;
    },
    isWsOpen() {
      return this.wsReadyState === WebSocket.OPEN;
    },
    chatUserId() {
      // Assumption: we identify callcenter user via localStorage or fallback.
      return (
        localStorage.getItem("user_id") ||
        localStorage.getItem("staff_id") ||
        "callcenter-admin"
      ).toString();
    },
    connectionClass() {
      if (this.connectionStatus === "Connected") return "ok";
      if (this.connectionStatus.includes("Error")) return "err";
      if (this.connectionStatus.includes("Disconnect")) return "warn";
      return "pending";
    },
  },
  methods: {
    ...mapActions({
      getOrderChatSetting: "fetchOrderDetailBack/getOrderChatSetting",
    }),
    closeDialogChat() {
      this.$emit("toggleDialogChat", this.openDialogChat);
      this.teardownWs();
    },
    resetChatState() {
      this.messages = [];
      this.inputText = "";
      this.connectionStatus = "Idle";
      this.chatJwt = null;
      this.connecting = false;
      this.wsReadyState = WebSocket.CLOSED;
      this.historyLoading = false;
      this.hasMoreHistory = true;
      this.historyOldestTs = null;
      this.messageKeys = new Set();
    },
    splitProvince(province) {
      let province_set = "";
      let province_split = province.split(" ");
      for (let val of province_split) {
        province_set += val;
      }
      return province_set;
    },
    async initChat() {
      if (!this.roomId) return;
      try {
        this.connectionStatus = "Preparing…";
        await this.fetchChatToken();
        await this.fetchHistory();
        this.connectWebSocket();
      } catch (e) {
        console.error(e);
        this.connectionStatus = "Error preparing chat";
      }
    },
    async fetchChatToken() {
      // Get a JWT for websocket auth (role fixed as callcenter for back-office)
      if (this.chatJwt) return;
      const base =
        process.env.VUE_APP_CHAT_SERVER ||
        window.CHAT_SERVER ||
        "http://localhost:8080";
      try {
        const res = await axios.post(`${base}/token`, {
          userId: this.chatUserId,
          role: "callcenter",
        });
        this.chatJwt = res.data.token;
      } catch (e) {
        throw new Error("Failed to fetch chat token");
      }
    },
    wsBaseUrl() {
      const base =
        process.env.VUE_APP_CHAT_SERVER ||
        window.CHAT_SERVER ||
        "http://localhost:8080";
      // Convert http(s) -> ws(s)
      if (base.startsWith("https://"))
        return base.replace("https://", "wss://");
      if (base.startsWith("http://")) return base.replace("http://", "ws://");
      // assume already ws
      return base;
    },
    connectWebSocket() {
      if (!this.chatJwt || !this.roomId) return;
      if (this.ws) this.teardownWs();
      const url = `${this.wsBaseUrl()}/ws?token=${this.chatJwt}`;
      this.connecting = true;
      this.connectionStatus = "Connecting…";
      const ws = new WebSocket(url);
      this.ws = ws;
      this.wsReadyState = WebSocket.CONNECTING;
      ws.onopen = () => {
        this.connecting = false;
        this.wsReadyState = WebSocket.OPEN;
        this.connectionStatus = "Connected";
        // Join room
        ws.send(
          JSON.stringify({
            type: "join",
            roomId: this.roomId,
          })
        );
      };
      ws.onmessage = (evt) => {
        try {
          const data = JSON.parse(evt.data);

          this.handleIncomingMessage(data);
        } catch (e) {
          console.warn("Bad message", e);
        }
      };
      ws.onclose = () => {
        this.connecting = false;
        this.wsReadyState = WebSocket.CLOSED;
        this.connectionStatus = this.openDialogChat ? "Disconnected" : "Closed";
        if (this.openDialogChat) {
          // auto-reconnect after short delay
          setTimeout(() => {
            if (this.openDialogChat) this.reconnect();
          }, 3000);
        }
      };
      ws.onerror = () => {
        this.connecting = false;
        // Most browsers don't give a distinct error readyState; treat as closed-ish.
        this.wsReadyState = ws.readyState;
        this.connectionStatus = "Error";
      };
    },
    teardownWs() {
      if (this.ws) {
        try {
          this.ws.close();
        } catch {}
        this.ws = null;
      }
      this.wsReadyState = WebSocket.CLOSED;
    },
    normalizeIncomingMessage(data) {
      if (!data || !data.type) return null;
      if (!["message", "image"].includes(data.type)) return null;

      const from =
        data.from ||
        (data.userId ? { userId: data.userId, role: data.role } : null);

      // Many servers send either `message`, `text`, or `payload.text`.
      const text =
        (data.payload && (data.payload.text || data.payload.message)) ||
        data.text ||
        data.message ||
        "";
      const imageUrl =
        (data.payload && data.payload.imageUrl) || data.imageUrl || undefined;
      const clientMessageId =
        (data.payload && data.payload.clientMessageId) ||
        data.clientMessageId ||
        undefined;

      return {
        type: data.type,
        roomId: data.roomId || this.roomId,
        from: from || { userId: "system", role: "system" },
        message: data.type === "message" ? text : undefined,
        imageUrl: data.type === "image" ? imageUrl : undefined,
        ts: data.ts || Date.now(),
        clientMessageId,
      };
    },
    handleIncomingMessage(data) {
      const msg = this.normalizeIncomingMessage(data);
      if (!msg) return;

      // Drop server echo of an optimistic message if the server doesn't preserve ids.
      if (this.isEchoOfOptimistic(msg)) {
        return;
      }

      if (!this.isDuplicateMessage(msg)) {
        this.messages.push(msg);
        this.registerMessageKey(msg);
        this.$nextTick(this.scrollMessagesToEnd);
      }
    },
    isEchoOfOptimistic(msg) {
      if (!msg || msg.type !== "message") return false;
      if (!msg.from || msg.from.userId !== this.chatUserId) return false;
      if (!msg.message) return false;
      // If server includes clientMessageId, messageKeys will handle it.
      // Fallback: same sender + same text within a short window.
      const windowMs = 4000;
      const nowTs = msg.ts || Date.now();
      for (
        let i = this.messages.length - 1;
        i >= 0 && i >= this.messages.length - 20;
        i--
      ) {
        const existing = this.messages[i];
        if (!existing || existing.type !== "message") continue;
        if (!existing.from || existing.from.userId !== this.chatUserId)
          continue;
        if (existing.message !== msg.message) continue;
        const existingTs = existing.ts || 0;
        if (Math.abs(nowTs - existingTs) <= windowMs) return true;
      }
      return false;
    },
    scrollMessagesToEnd() {
      const el = this.$refs.messagesContainer;
      if (el) el.scrollTop = el.scrollHeight;
    },
    makeClientMessageId() {
      return `c_${Date.now().toString(36)}_${Math.random()
        .toString(36)
        .slice(2, 9)}`;
    },
    sendMessage() {
      if (!this.inputText || !this.isWsOpen || !this.roomId) return;
      const orderType = this.currentOrder
        ? this.currentOrder.order_type == 1
          ? "food"
          : "messenger"
        : "";
      const userName =
        (this.currentOrder && this.currentOrder.order_customer_full_name) ||
        "Customer";
      const userPhone =
        (this.currentOrder &&
          this.currentOrder.order_customer &&
          this.currentOrder.order_customer.customer_tel) ||
        (this.currentOrder && this.currentOrder.order_customer_tel) ||
        "";
      const clientMessageId = this.makeClientMessageId();
      const payload = {
        type: "message",
        roomId: this.roomId,
        clientMessageId,
        // Compatibility fields (some servers read `message` or `text`)
        message: this.inputText,
        text: this.inputText,
        payload: {
          text: this.inputText,
          orderType,
          userName,
          userPhone,
          clientMessageId,
        },
      };
      try {
        this.ws.send(JSON.stringify(payload));
        // Optimistic add (will also receive back from server broadcast)
        const optimistic = {
          type: "message",
          roomId: this.roomId,
          from: { userId: this.chatUserId, role: "callcenter" },
          message: this.inputText,
          ts: Date.now(),
          clientMessageId,
        };
        if (!this.isDuplicateMessage(optimistic)) {
          this.registerMessageKey(optimistic);
          this.messages.push(optimistic);
        }
        this.inputText = "";
        this.$nextTick(this.scrollMessagesToEnd);
      } catch (e) {
        console.error("Send failed", e);
      }
    },
    chatServerBase() {
      return (
        process.env.VUE_APP_CHAT_SERVER ||
        window.CHAT_SERVER ||
        "http://localhost:8080"
      );
    },
    async fetchHistory(beforeTs) {
      if (!this.currentOrder) return;
      if (this.historyLoading) return;
      this.historyLoading = true;
      try {
        const params = {};
        if (beforeTs) params.beforeTs = beforeTs;
        const limit = 50; // default server limit
        const url = `${this.chatServerBase()}/history/${
          this.currentOrder.order_code
        }`;
        const res = await axios.get(url, { params: { ...params, limit } });
        const items = (res.data && res.data.items) || [];
        if (items.length === 0) {
          if (!beforeTs) this.hasMoreHistory = false;
          this.historyLoading = false;
          return;
        }
        // Map items to message format
        const mapped = items.map((it) => ({
          type: it.kind === "image" ? "image" : "message",
          roomId: it.roomId,
          from: it.userId
            ? { userId: it.userId, role: it.role }
            : { userId: "unknown", role: it.role || "system" },
          message:
            it.kind === "text"
              ? it.text
              : it.kind === "e2ee"
              ? "(encrypted)"
              : it.text,
          imageUrl: it.kind === "image" ? it.imageUrl : undefined,
          ts: it.ts,
        }));
        if (!beforeTs) {
          // Initial load
          this.messages = [];
          mapped.forEach((m) => {
            if (!this.isDuplicateMessage(m)) {
              this.registerMessageKey(m);
              this.messages.push(m);
            }
          });
          this.$nextTick(this.scrollMessagesToEnd);
        } else {
          // Prepend older messages while preserving scroll position
          const container = this.$refs.messagesContainer;
          const prevHeight = container ? container.scrollHeight : 0;
          const toAdd = [];
          mapped.forEach((m) => {
            if (!this.isDuplicateMessage(m)) {
              this.registerMessageKey(m);
              toAdd.push(m);
            }
          });
          this.messages = [...toAdd, ...this.messages];
          this.$nextTick(() => {
            if (container) {
              const newHeight = container.scrollHeight;
              container.scrollTop = newHeight - prevHeight; // maintain relative position
            }
          });
        }
        // Update oldest ts
        const oldest = mapped[0];
        if (oldest) this.historyOldestTs = oldest.ts;
        // Heuristic: if returned less than limit, no more
        if (items.length < limit) this.hasMoreHistory = false;
      } catch (e) {
        console.error("Failed to load history", e);
        // On error, allow retry
      } finally {
        this.historyLoading = false;
      }
    },
    loadOlderHistory() {
      if (!this.historyOldestTs) return;
      this.fetchHistory(this.historyOldestTs);
    },
    onScrollMessages(e) {
      const el = e.target;
      if (el.scrollTop < 60 && this.hasMoreHistory && !this.historyLoading) {
        this.loadOlderHistory();
      }
    },
    buildMessageKey(m) {
      if (m && m.clientMessageId) {
        return ["client", m.roomId, m.clientMessageId].join("|");
      }
      return [
        m.roomId,
        m.ts,
        m.from && m.from.userId,
        m.from && m.from.role,
        m.type,
        m.message,
        m.imageUrl,
      ].join("|");
    },
    isDuplicateMessage(m) {
      const key = this.buildMessageKey(m);
      return this.messageKeys.has(key);
    },
    registerMessageKey(m) {
      const key = this.buildMessageKey(m);
      this.messageKeys.add(key);
    },
    reconnect() {
      if (this.connecting) return;
      this.connectWebSocket();
    },
    formatTime(ts) {
      if (!ts) return "";
      try {
        return new Date(ts).toLocaleTimeString();
      } catch {
        return "";
      }
    },
    chooseAttachment() {
      // Placeholder for future image/file upload integration
      // Could open a hidden file input and then POST to /upload
      this.$emit("openAttachmentDialog");
    },
  },
};
</script>

<style scoped>
.chat-log {
  border: solid black 0px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
}
.header {
  background-color: white;
  color: black;
}

.img-animate {
  animation: lds-circle 5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.chat-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 8px 10px 12px;
  background: #fafafa;
}
/* Redesigned styles */
.status-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff3b0;
  padding: 4px 8px;
  border-bottom: 1px solid #e2d48a;
  font-size: 12px;
}
.status-left {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #bbb;
}
.dot.ok {
  background: #2e7d32;
}
.dot.warn {
  background: #f9a825;
}
.dot.err {
  background: #d32f2f;
}
.dot.pending {
  background: #0288d1;
}
.history-indicator {
  opacity: 0.7;
  font-style: italic;
}

.message-row {
  display: flex;
  margin: 6px 0;
}
.message-row.mine {
  justify-content: flex-end;
}
.bubble {
  max-width: 78%;
  background: #ffffff;
  padding: 6px 10px 8px;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  position: relative;
  font-size: 13px;
  line-height: 1.35;
  word-break: break-word;
}
.message-row.mine .bubble {
  background: #ffe04d;
}
.bubble-meta {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 2px;
  opacity: 0.65;
}
.bubble-text {
  white-space: pre-wrap;
}
.bubble-text.alt {
  font-style: italic;
  opacity: 0.7;
}
.bubble-image img {
  max-width: 180px;
  border-radius: 8px;
  display: block;
}

.role {
  text-transform: uppercase;
  font-weight: 600;
}
.role.r-callcenter {
  color: #1e88e5;
}
.role.r-customer {
  color: #6a1b9a;
}
.role.r-rider {
  color: #2e7d32;
}

.date-separator {
  text-align: center;
  margin: 12px 0 4px;
  position: relative;
}
.date-separator span {
  background: #e0e0e0;
  color: #424242;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 11px;
}

.top-fade {
  height: 20px;
  background: linear-gradient(#fafafa, rgba(250, 250, 250, 0));
  margin-bottom: 4px;
}

.loading-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 30px 0;
  font-size: 13px;
  opacity: 0.8;
}
.empty {
  text-align: center;
  padding: 40px 0;
  font-size: 13px;
  opacity: 0.55;
}

.composer {
  border-top: 1px solid #e0e0e0;
  background: #fff;
  padding: 6px 8px 8px;
}
.composer-row {
  display: flex;
  gap: 6px;
  align-items: flex-end;
}
.composer-input {
  flex: 1;
}
.attach-btn {
  margin-top: -2px;
}
.send-btn {
  min-width: 64px;
}

/* Scrollbar tweak (webkit) */
.chat-messages::-webkit-scrollbar {
  width: 8px;
}
.chat-messages::-webkit-scrollbar-track {
  background: transparent;
}
.chat-messages::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

@keyframes lds-circle {
  0%,
  100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}
</style>
